import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface WellAttachment {
  id: number;
  fileName: string;
  wellID: number;
  description: string;
  uploadedBy: string;
}

@Injectable({ providedIn: 'root' })
export class WellAttachmentsService {
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getByWellId(wellId: number): Observable<WellAttachment[]> {
    return this.http.get<WellAttachment[]>(`${this.baseUrl}/tree-node-operation/well-attachments/${wellId}`);
  }

  openAttachment(attachmentId: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/tree-node-operation/well-attachments/content/${attachmentId}`, { responseType: 'blob' });
  }

  updateDescription(attachmentId: number, description: string): Observable<any> {
    return this.http.patch(`${this.baseUrl}/tree-node-operation/well-attachments`, { fileId: attachmentId, description });
  }

  upload(wellId: number, formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/tree-node-operation/well-attachments/upload/${wellId}`, formData);
  }

  delete(wellId: number, attachmentId: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/tree-node-operation/well-attachments`, { body: { fileId: attachmentId, wellId } });
  }
}
